import { Field, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { Input } from 'cat-ecommerce-alloy';
import { NOTE_FIELD_MAX_LENGTH } from '../../../constants';
import style from '../../../styles.module.scss';

const InputField = ({ item }) => {
  const { id, key } = item;
  const { values, setFieldValue } = useFormikContext();
  const disabledState = !values[id].radioValue;
  const inputFieldName = `${id}.inputValue`;
  return (
    <Field
      as={Input}
      id={id}
      maxLength={NOTE_FIELD_MAX_LENGTH[key]}
      name={id}
      type="text"
      value={values[id].inputValue}
      onChange={event => setFieldValue(inputFieldName, event.target.value)}
      disabled={disabledState}
      className={style['note-text-field']}
    />
  );
};

InputField.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    key: PropTypes.string
  })
};

export default InputField;
